module.exports = __webpack_public_path__ + "img/boquete-brewing.39f47fc9.png";